module.exports = __webpack_public_path__ + "static/media/trash-2.ff7253d2.svg";